"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var uuid_1 = require("uuid");
;
var getMessageId = function () {
    return (0, uuid_1.v4)();
};
var createBaseWebsocket = function (_a) {
    var wsUrl = _a.wsUrl, _b = _a.keepAliveIntervalMs, keepAliveIntervalMs = _b === void 0 ? 20000 : _b, _c = _a.connectionTimeoutMs, connectionTimeoutMs = _c === void 0 ? 1000 : _c, _d = _a.reconnectTimeoutMs, reconnectTimeoutMs = _d === void 0 ? 105 * 60 * 1000 : _d, _e = _a.onReconnect, onReconnect = _e === void 0 ? function () { } : _e;
    return __awaiter(void 0, void 0, void 0, function () {
        var ws, messageListeners, pendingPromises, setUpWebsocketListeners, send, close, onMessage, offMessage, api;
        return __generator(this, function (_f) {
            ws = new WebSocket(wsUrl);
            messageListeners = [];
            pendingPromises = {};
            setUpWebsocketListeners = function () {
                var keepAliveInterval = setInterval(function () {
                    if (ws.OPEN) {
                        ws.send(JSON.stringify({ action: 'KeepAlive ' }));
                    }
                }, keepAliveIntervalMs);
                var reconnectInterval = setInterval(function () { return __awaiter(void 0, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                console.log('reconnecting to bchat websocket...');
                                return [4, close()];
                            case 1:
                                _a.sent();
                                ws = new WebSocket(wsUrl);
                                ws.onopen = function () {
                                    console.log('reconnected to bchat websocket');
                                    onReconnect();
                                };
                                setUpWebsocketListeners();
                                return [2];
                        }
                    });
                }); }, reconnectTimeoutMs);
                ws.onclose = function () {
                    var _a;
                    console.log('bchat websocket closed');
                    clearTimeout(keepAliveInterval);
                    clearTimeout(reconnectInterval);
                    (_a = pendingPromises['wsClose']) === null || _a === void 0 ? void 0 : _a.res({});
                };
                ws.onmessage = function (_a) {
                    var data = _a.data;
                    var message = JSON.parse(data);
                    if (message.eventType === 'Response') {
                        var _b = pendingPromises[message.eventId], res = _b.res, rej = _b.rej;
                        message.success
                            ? res(message.data)
                            : rej(message.data.error);
                        delete pendingPromises[message.eventId];
                        return;
                    }
                    ;
                    for (var _i = 0, messageListeners_1 = messageListeners; _i < messageListeners_1.length; _i++) {
                        var listenerFunction = messageListeners_1[_i];
                        listenerFunction(message);
                    }
                };
            };
            send = function (messageData, timeout) {
                if (timeout === void 0) { timeout = 3000; }
                var eventId = getMessageId();
                return new Promise(function (res, rej) {
                    console.log('sending bchat message...', messageData);
                    ws.send(JSON.stringify(__assign(__assign({}, messageData), { eventId: eventId })));
                    pendingPromises[eventId] = { res: res, rej: rej };
                    setTimeout(function () {
                        var _a;
                        (_a = pendingPromises[eventId]) === null || _a === void 0 ? void 0 : _a.rej("websocket event with ".concat(eventId, " timed out"));
                    }, timeout);
                });
            };
            close = function () { return new Promise(function (res, rej) {
                pendingPromises['wsClose'] = { res: res, rej: rej };
                ws.close();
            }); };
            onMessage = function (func) {
                messageListeners.push(func);
            };
            offMessage = function (func) {
                messageListeners = messageListeners.filter(function (f) { return f !== func; });
            };
            api = {
                send: send,
                close: close,
                onMessage: onMessage,
                offMessage: offMessage
            };
            return [2, new Promise(function (res, rej) {
                    var timeout = setTimeout(function () { return rej('websocket connection timeout'); }, connectionTimeoutMs);
                    setUpWebsocketListeners();
                    ws.onopen = function () {
                        res(api);
                        clearTimeout(timeout);
                    };
                })];
        });
    });
};
exports.default = createBaseWebsocket;
